import { axios } from "@Root/API";

export const putContactsDioceseForm = (contactId, data) => {
  return axios.put("diocese-detail", { ...data, id: contactId });
};
